import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const fallbackLeague = [
  { day: 'Mon', time: '6.30 pm - 9.30 pm', enabled: true },
  { day: 'Tue', time: '6.30 pm - 10.00 pm', enabled: true },
  { day: 'Wed', time: '6.30 pm - 9.30 pm', enabled: true },
  { day: 'Thu', time: '6.30 pm - 9.30 pm', enabled: true },
  { day: 'Fri', time: '6.30 pm - 9.30 pm', enabled: true },
  { day: 'Sat', time: '12.00 pm - 10.00 pm', enabled: true },
];

const fallbackOpen = [
  { day: 'Mon', time: '3.00 pm - 4.30 pm', enabled: true },
  { day: 'Tue', time: '3.00 pm - 4.30 pm', enabled: true },
  { day: 'Wed', time: '3.00 pm - 4.30 pm', enabled: true },
  { day: 'Thu', time: '10.00 am - 4.30 pm', enabled: true },
  { day: 'Fri', time: '3.00 pm - 10.00 pm', enabled: true, tags: 'Rock & Bowl, Reg Lanes' },
  { day: 'Sat', time: '12.00 pm - 10.00 pm', enabled: true, tags: 'Rock & Bowl, Reg Lanes' },
  { day: 'Sun', time: '12.00 pm - 10.00 pm', enabled: true },
];

function Hours() {
  const [leagueTimings, setLeagueTimings] = useState(fallbackLeague);
  const [openTimings, setOpenTimings] = useState(fallbackOpen);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'schedule', 'timings'), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.league) setLeagueTimings(data.league);
        if (data.open) setOpenTimings(data.open);
      }
    }, (err) => {
      console.error('Error listening to schedule:', err);
    });
    return () => unsubscribe();
  }, []);

  const activeLeague = leagueTimings.filter((t) => t.enabled);
  const activeOpen = openTimings.filter((t) => t.enabled);

  return (
    <section className="hours section-padding" id="hours">
      <div className="container">
        <div className="hours-header">
          <h5>Our Schedule</h5>
          <h2>Hours & Timings</h2>
        </div>
        <div className="hours-grid">
          <div className="hours-card">
            <h3>Leagues Timings</h3>
            <ul className="hours-list">
              {activeLeague.map((item, index) => (
                <li key={index}>
                  <span className="hours-day">{item.day}</span>
                  <span className="hours-time">{item.time}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="hours-card">
            <h3>Open Timings</h3>
            <ul className="hours-list">
              {activeOpen.map((item, index) => (
                <li key={index}>
                  <span className="hours-day">{item.day}</span>
                  <div className="hours-time-wrap">
                    <span className="hours-time">{item.time}</span>
                    {item.tags && (
                      <div className="hours-extra">
                        {item.tags.split(',').map((tag, i) => (
                          <span key={i} className="hours-tag">{tag.trim()}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hours;
